import type { ComboBoxValueComponentProps } from '../../../../cdl/ComboBox/types/ComboBoxComponentProps';
import { Tag } from '../../../../cdl/Tag/Tag';
import { Text } from '../../../../cdl/Text/Text';
import { translate } from '../../../helpers/translate.helper';
import { Characters } from '../../../helpers/unicode.helper';
import { useEnums } from '../../../hooks/useEnums';
import { Box } from '../../../ui/Box';
import type { ProductOption } from '../ProductOption';

interface ProductSingleValueProps extends ComboBoxValueComponentProps<ProductOption> {
    disabled?: boolean;
}

export const ProductSingleValue = ({ option, disabled }: ProductSingleValueProps) => {
    const { getHumanReadableValue } = useEnums();

    const supplierProductGroupString = `(${getHumanReadableValue(
        'supplierProductGroup',
        option.product.supplierProductGroup
    )})`;

    return (
        <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            gap={8}
            minWidth={0}
            overflow="hidden"
            width="100%"
        >
            <Text truncated style={{ flex: 1 }}>
                {option.product.name}
                {Characters.NO_BREAK_SPACE}
                {supplierProductGroupString}
            </Text>

            {option.inTank && !disabled ? (
                <Box flexShrink={0}>
                    <Tag variant="default">{translate('productSelect.inTank')}</Tag>
                </Box>
            ) : null}
        </Box>
    );
};
